import React from "react"
import { useAdertisementData } from "./utils"

export const NodigAds = ({ place, adbutler_page_id }) => {
  // Client-side Runtime Data Fetching
  // const nodigAdURL = `https://servedbyadbutler.com/adserve/;ID=169218;size=0x0;setID=438802;type=json;pid=${adbutler_page_id};place=${place};click=CLICK_MACRO_PLACEHOLDER`

  const state = useAdertisementData({
    adbutler_page_id: adbutler_page_id,
    set_id: "438802",
    place: place,
  })

  return (
    <div data-nosnippet>
      {state.body ? (
        <div>
          <div className="ad-disclaimer">Anzeige</div>
          <div
            dangerouslySetInnerHTML={{ __html: state.body }}
            key={state.banner_id}
          ></div>
        </div>
      ) : (
        state.imageURL && (
          <div key={state.banner_id}>
            <div className="ad-disclaimer">Anzeige</div>
            <div>
              <a
                href={state.redirectURL}
                target={state.link_target}
                rel="noopener noreferrer"
                title={`Anzeige`}
              >
                <img
                  src={state.imageURL}
                  alt={`Anzeige`}
                  title={`Anzeige`}
                  style={{ maxWidth: "300px", width: "100%", height: "auto" }}
                />
              </a>
            </div>
          </div>
        )
      )}
    </div>
  )
}
